import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';
import React, { CSSProperties } from 'react';

export interface FacebookLoadingProps {
    width: string | number;
    height: string | number;
    marginTop?: number | string;
    marginBottom?: number | string;
    marginLeft?: number | string;
    marginRight?: number | string;
    borderRadius: number | string;
    style?: CSSProperties;
    className?: string;
}

const placeHolderShimmer = keyframes({
    '0%': { backgroundPosition: '-468px 0' },
    '100%': { backgroundPosition: '468px 0' },
});

const LoadingPlaceholder = styled('div')({
    animation: `${placeHolderShimmer} 1s linear infinite forwards`,
    background:
        'linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%)',
    backgroundSize: '800px 104px',
});

export const FacebookLoading: React.FCC<FacebookLoadingProps> = React.memo(
    ({
        width,
        height,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        borderRadius,
        style,
        className,
    }) => (
        <LoadingPlaceholder
            className={className}
            style={{
                ...style,
                width,
                height,
                marginTop,
                marginRight,
                marginBottom,
                marginLeft,
                borderRadius,
            }}
        />
    ),
);
